import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { getStorage } from '@src/utils/enhancedStorage'

import { IExperimentLoggingData } from '../experiments.types'

import { StatsigExperimentBucket } from './statsig.types'

const LOCALSTORAGE_KEY = 'statsigExperimentBuckets'

export class StatsigExperimentManager {
  exposedBuckets: Record<string, StatsigExperimentBucket>

  constructor() {
    this.exposedBuckets = {}
  }

  initialize() {
    const existingBuckets = this.getExposedBucketsFromLocalStorage()

    existingBuckets.forEach(
      ({ experimentName, bucketName, isActive } = { experimentName: '', bucketName: '', isActive: false }) => {
        if (!experimentName || !bucketName) return
        this.exposedBuckets[experimentName] = {
          experimentName,
          bucketName,
          isActive,
        }
      },
    )
  }

  setExposedBuckets(buckets: StatsigExperimentBucket[], replaceBuckets = false) {
    if (replaceBuckets) {
      this.exposedBuckets = {}
    }
    buckets.forEach(bucket => {
      this.exposedBuckets[bucket.experimentName] = bucket
    })

    this.setExposedBucketsInLocalStorage()
  }

  getExposedBuckets() {
    const experimentBuckets: StatsigExperimentBucket[] = []
    Object.entries(this.exposedBuckets).forEach(([experimentName, bucket]) => {
      experimentBuckets.push({
        experimentName,
        bucketName: bucket.bucketName,
        isActive: bucket.isActive,
      })
    })
    return Object.freeze(experimentBuckets)
  }

  getActiveExposedBuckets() {
    return this.getExposedBuckets().filter(bucket => {
      // bucket is active can be undefined for users not exposed to experiment after isActive key was added
      return bucket.isActive ?? true
    })
  }

  private setExposedBucketsInLocalStorage() {
    try {
      if (!isBrowser()) return void 0

      const experimentBuckets = this.getExposedBuckets()

      getStorage().setItem(LOCALSTORAGE_KEY, JSON.stringify(experimentBuckets))
    } catch (error) {
      console.error(`Failed to set Statsig Experiment buckets in Local storage: `, error)
    }
  }

  private getExposedBucketsFromLocalStorage() {
    try {
      if (!isBrowser()) return []

      const existingBuckets = JSON.parse(getStorage().getItem(LOCALSTORAGE_KEY) ?? '[]') as IExperimentLoggingData[]
      if (!Array.isArray(existingBuckets)) {
        return []
      }
      return existingBuckets
    } catch (error) {
      console.error(`Failed to get Statsig Experiment buckets from Local storage: `, error)
      return []
    }
  }
}

export const statsigExperimentManager = new StatsigExperimentManager()
